<template>
  <div class="schoolList">
    <div class="wrapper" @click.stop>
      <div style=" width: 100%;">
        <van-search
          v-model="schoolName"
          show-action
          placeholder="请输入搜索关键词"
          @input="onSearch"
          @cancel="onCancel"
        />
      </div>
      <div v-if="schoolList.length>0" style="overflow:auto;height: 100%;" class="organ_list">
        <van-list>
          <van-cell
            v-for="(item, index) in schoolList"
            :key="index"
            :title="item.name"
            @click="checkedSchoolItem(item)"
          />
        </van-list>
      </div>
      <div v-else style="text-align:center;margin-top:10rem">
        <div v-show="isAddschool">
          <div>
            <img src="./../assets/imgs/no_find@2x.png" alt srcset style="height:4rem" />
          </div>
          <p style="color:#999999;font-size:1.5rem">没有找到学校</p>
          <div class="add_btn" @click="addSchool()">新增院校</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import user_service from "./../service/user_service";
const PinyinEngine = require("pinyin-engine");
const pinyin = require("pinyin");
export default {
  data() {
    return {
      schoolName: "",
      schoolList: [],
      school: "",
      isAddschool: false
    };
  },
  created() {
    this.checkSchool();
  },
  methods: {
    async checkSchool() {
      // 查询机构列表
      let result = await user_service.searchOrganList();

      // 数字、大小写中文开头的机构放到最后拼接
      let specialData =[];
      for (let i = 0; i < result.data.length; i++) {
        if (!/^[\u4e00-\u9fa5]+$/.test(result.data[i].name.substring(0, 1))) {
          specialData.push(result.data[i])
          result.data.splice(i, 1);
          i--;
        }
      }
      // 添加拼音属性
      result.data.forEach(x => (x.pinyin = pinyin(x.name, {style: pinyin.STYLE_NORMAL}).join("")));
     
      // 按照拼音排序
      result.data.sort((a, b) => {
        return a.pinyin > b.pinyin ? 1 : a.pinyin < b.pinyin ? -1 : 0;
      });
      console.log(result);
      this.schoolList = this.allSchoolList = result.data.concat(specialData);

      if (this.schoolName) {
        const pinyinEngine = new PinyinEngine(this.allSchoolList, ["name"]);
        this.schoolList = pinyinEngine
          .query(this.schoolName)
          .sort(function(a, b) {
            return (
              a.name.indexOf(this.schoolName) - b.name.indexOf(this.schoolName)
            );
          });
      }
      this.isAddschool = !this.schoolList.length > 0;
    },
    //
    onSearch(value) {
      console.log(value);
      const pinyinEngine = new PinyinEngine(this.allSchoolList, ["name"]);
      this.schoolList = pinyinEngine.query(value).sort(function(a, b) {
        return a.name.indexOf(value) - b.name.indexOf(value);
      });
      this.isAddschool = !this.schoolList.length > 0;
      console.log(this.schoolList);
    },
    onCancel() {
      this.school = "";
      this.schoolName = "";
      this.$router.push(
        "/info?sId=" +
          this.school +
          "&sName=" +
          encodeURIComponent(this.schoolName)
      );
    },
    checkedSchoolItem(school) {
      this.school = school.oid;
      this.schoolName = school.name;
      this.$router.push(
        "/info?sId=" +
          this.school +
          "&sName=" +
          encodeURIComponent(this.schoolName)
      );
    },
    addSchool() {
      this.school = "";
      this.$router.push(
        "/addSchool?school=" + encodeURIComponent(this.schoolName)
      );
    }
  }
};
</script>
<style scoped>
.add_btn {
  font-size: 1.5rem;
  height: 4rem;
  width: 30%;
  padding-left: 2rem;
  padding-right: 2rem;
  line-height: 4rem;
  background: #009bfe;
  border-radius: 3rem;
  display: inline-block;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/schoolList.vue